import { render, staticRenderFns } from "./luntai.vue?vue&type=template&id=64d40dd2&scoped=true"
import script from "./luntai.vue?vue&type=script&lang=js"
export * from "./luntai.vue?vue&type=script&lang=js"
import style0 from "./luntai.vue?vue&type=style&index=0&id=64d40dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d40dd2",
  null
  
)

export default component.exports